import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import type {
  CreateProcessoPayload,
  EtapaProcesso,
  Paginacao,
  ProcessoDetalhe,
  ProcessoListItem,
  UpdateProcessoPayload,
} from '@/types/processos/processoStoreTypes';

interface ListaProcessosResponse {
  data: ProcessoListItem[];
  pagination: Paginacao;
}

export const processosService = {
  listar: async (params?: {
    search?: string;
    status?: string;
    categoriaId?: string;
    setorId?: string;
    page?: number;
    limit?: number;
  }) => {
    const response = await apiGet('/processos', params);
    if (!response.ok) throw new Error('Erro ao listar processos');
    const body = await response.json();
    return body.data as ListaProcessosResponse;
  },
  buscarPorId: async (id: string) => {
    const response = await apiGet(`/processos/${id}`);
    if (!response.ok) throw new Error('Erro ao buscar processo');
    const body = await response.json();
    return body.data as ProcessoDetalhe;
  },
  criar: async (payload: CreateProcessoPayload) => {
    const response = await apiPost('/processos', payload);
    if (!response.ok) throw new Error('Erro ao criar processo');
    const body = await response.json();
    return body.data as ProcessoDetalhe;
  },
  atualizar: async (id: string, payload: UpdateProcessoPayload) => {
    const response = await apiPut(`/processos/${id}`, payload);
    if (!response.ok) throw new Error('Erro ao atualizar processo');
    const body = await response.json();
    return body.data as ProcessoDetalhe;
  },
  patchEtapa: async (id: string, etapa: EtapaProcesso) => {
    const response = await apiPatch(`/processos/${id}/etapa`, { etapa });
    if (!response.ok) throw new Error('Erro ao atualizar etapa');
    const body = await response.json();
    return body.data as ProcessoDetalhe;
  },
  remover: async (id: string) => {
    const response = await apiDelete(`/processos/${id}`);
    if (!response.ok) throw new Error('Erro ao deletar processo');
  },
};
